import { render, staticRenderFns } from "./SidebarSearch.vue?vue&type=template&id=30717312"
import script from "./SidebarSearch.vue?vue&type=script&lang=js"
export * from "./SidebarSearch.vue?vue&type=script&lang=js"
import style0 from "./SidebarSearch.vue?vue&type=style&index=0&id=30717312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports